import { HandlingServicesPrebillingDto, OrderDto, StockDto } from '@billing/app/api'
import { SelectOption } from '@billing/app/models'
import exportService from '@billing/services/ExportService'
import ordersService from '@billing/services/OrdersService'
import { CompanyStore } from '@billing/stores/CompanyStore'
import { Dayjs } from 'dayjs'
import { action, makeObservable, observable, runInAction } from 'mobx'

export class HandlingServicesPreBillingUIStore {
  customerId = ''
  from?: Dayjs
  to?: Dayjs
  orders: OrderDto[] = []
  stockInventories: StockDto[] = []
  ordersToBePreBilled: number[] | null = null

  handlingData: HandlingServicesPrebillingDto[] = []
  isLoading = false

  constructor(private readonly _customerStore: CompanyStore) {
    makeObservable(this, {
      from: observable,
      to: observable,
      customerId: observable,
      orders: observable,
      ordersToBePreBilled: observable,
      handlingData: observable,
      isLoading: observable,

      setCustomerId: action,
      setFrom: action,
      setTo: action,
      loadData: action,
      setIdsToSubmit: action,
    })
  }

  async fetchHandlingData() {
    this.isLoading = true
    try {
      const result = await exportService.getHandlingServicesData(
        parseInt(this.customerId),
        this.from,
        this.to,
      )
      runInAction(() => {
        this.handlingData = result.data || []
      })
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }

  setCustomerId(customerId: string) {
    this.customerId = customerId
  }

  get customerOptions(): SelectOption[] {
    return this._customerStore.items.map(c => ({ label: c.name, value: c.id.toString() }))
  }

  setFrom(from?: Dayjs): void {
    this.from = from
  }

  setTo(to?: Dayjs): void {
    this.to = to
  }

  async loadData() {
    const result = await ordersService.getFulfilledOrders(
      this.customerId === 'All' ? undefined : parseInt(this.customerId),
      this.from?.toISOString(),
      this.to?.toISOString(),
    )

    runInAction(() => {
      this.orders = result
    })
  }

  resetFilter() {
    this.setFrom(undefined)
    this.setTo(undefined)
  }

  setIdsToSubmit(orderIds: number[]) {
    this.ordersToBePreBilled = orderIds
  }
}
